// extracted by mini-css-extract-plugin
export default {"container":"container_container__6AwuJ","fade-in":"container_fade-in__523rZ"};